/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ReportSessionMovedRequestBody = {
  /**
   * Email of the enrolled user. Authoritative when authenticating with an org-scoped agent install key (the MDM zero-touch path); ignored for a per-user key, whose owner is the enrolled user.
   */
  email?: string | undefined;
  /**
   * Native harness session identifier of the moved session. Speakeasy derives its chat id from this the same way hook ingest does; the move is recorded even if the session has not been captured yet.
   */
  sessionId: string;
  /**
   * Harness the session originated in, as detected by the agent (e.g. claude-code, codex).
   */
  sourceSurface?: string | undefined;
  /**
   * Harness the session was moved to (e.g. cursor, codex, claude-code).
   */
  targetHarness: string;
  /**
   * Native session id minted for the continuation, when the daemon knows it at launch time (claude-code targets today; Cursor mints ids server-side so moves there omit it). Lets Speakeasy link the original session and its continuation.
   */
  targetSessionId?: string | undefined;
};

/** @internal */
export type ReportSessionMovedRequestBody$Outbound = {
  email?: string | undefined;
  session_id: string;
  source_surface?: string | undefined;
  target_harness: string;
  target_session_id?: string | undefined;
};

/** @internal */
export const ReportSessionMovedRequestBody$outboundSchema: z.ZodMiniType<
  ReportSessionMovedRequestBody$Outbound,
  ReportSessionMovedRequestBody
> = z.pipe(
  z.object({
    email: z.optional(z.string()),
    sessionId: z.string(),
    sourceSurface: z.optional(z.string()),
    targetHarness: z.string(),
    targetSessionId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionId: "session_id",
      sourceSurface: "source_surface",
      targetHarness: "target_harness",
      targetSessionId: "target_session_id",
    });
  }),
);

export function reportSessionMovedRequestBodyToJSON(
  reportSessionMovedRequestBody: ReportSessionMovedRequestBody,
): string {
  return JSON.stringify(
    ReportSessionMovedRequestBody$outboundSchema.parse(
      reportSessionMovedRequestBody,
    ),
  );
}
